<script setup>
import { computed } from 'vue';
import { mentionFaviconUrl, mentionHost } from './buzzMentionHelpers';

const props = defineProps({
  domain: {
    type: String,
    default: '',
  },
  link: {
    type: String,
    default: '',
  },
});

const host = computed(() => mentionHost(props.domain, props.link));
const faviconUrl = computed(() => mentionFaviconUrl(props.domain, props.link));
const displayDomain = computed(() => props.domain || host.value || '—');
</script>

<template>
  <div class="flex items-center gap-2 min-w-0">
    <img
      v-if="faviconUrl"
      :src="faviconUrl"
      alt=""
      class="size-4 rounded-sm shrink-0"
    />
    <span class="text-n-slate-11 whitespace-nowrap truncate">{{
      displayDomain
    }}</span>
  </div>
</template>
